import { render, staticRenderFns } from "./CollectionsMenu.vue?vue&type=template&id=160e86d8&lang=pug&"
import script from "./CollectionsMenu.vue?vue&type=script&lang=js&"
export * from "./CollectionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160e86d8')) {
      api.createRecord('160e86d8', component.options)
    } else {
      api.reload('160e86d8', component.options)
    }
    module.hot.accept("./CollectionsMenu.vue?vue&type=template&id=160e86d8&lang=pug&", function () {
      api.rerender('160e86d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CollectionsMenu.vue"
export default component.exports